export const IconLink = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M18.588 9.567c-.488-.12-.981.16-1.105.618-.124.46.17.926.656 1.042 1.203.29 2.043 1.313 2.043 2.487 0 1.418-1.223 2.572-2.727 2.572H12c-1.504 0-2.727-1.154-2.727-2.572s1.223-2.571 2.727-2.571c.502 0 .909-.384.909-.857 0-.474-.407-.857-.91-.857-2.505 0-4.545 1.922-4.545 4.285S9.494 18 12 18h5.454C19.962 18 22 16.078 22 13.714c0-1.959-1.403-3.664-3.412-4.147" />
      <path d="M6.517 13.815c.124-.46-.17-.926-.656-1.042-1.203-.29-2.043-1.312-2.043-2.487 0-1.418 1.224-2.572 2.727-2.572H12c1.504 0 2.727 1.154 2.727 2.572S13.504 12.857 12 12.857c-.502 0-.91.384-.91.857 0 .474.408.857.91.857 2.506 0 4.545-1.922 4.545-4.285S14.506 6 12 6H6.546C4.038 6 2 7.923 2 10.286c0 1.959 1.403 3.664 3.412 4.148.488.12.981-.16 1.105-.62" />
    </svg>
  );
};
